import React from "react";
import { ContentSectionProps } from "./types";
import { CmsSeparator } from "../../types/cms";

const Separator: React.FC<ContentSectionProps<CmsSeparator>> = ({
  data,
  heading,
}) => {
  return (
    <div className="my-8">
      {heading}
      <div className="flex items-center">
        <div className="flex-grow h-px bg-gray-300"></div>
        <span className="px-4 text-gray-500">{data.symbol}</span>
        <div className="flex-grow h-px bg-gray-300"></div>
      </div>
    </div>
  );
};

export default Separator;
